<template>
  <tr @click="handlePatientClick" class="order">
    <td>{{ item.name }}</td>
    <td>{{ reformatDate(item.birthday) | NoEmpty }}</td>
    <td>{{ item.createdAt | DateWithMinutes}}</td>
    <td>{{clientTitles}}</td>
    <td>
      <span v-for="c in item.patientCases" class="ml-1">
        <router-link :to="{ name: 'updatePgtCase', params: { caseSystemId: c.caseSystemId }}">{{c.caseSystemId}}</router-link>
      </span>
    </td>
    <td>{{item.comment | NoEmpty}}</td>
  </tr>
</template>

<script>

import NoEmpty from 'js-core/components/Filters/NoEmpty'
import DateWithMinutes from 'js-core/components/Filters/DateWithMinutes'
import _ from 'lodash'
import {reformatDate} from '@/helpers/timeformats'

export default {
  name: 'OrderListItem',
  props: {
    item: Object,
    availableClientsById: Object,
  },
  filters: {
    NoEmpty,
    DateWithMinutes
  },
  components: {
  },
  computed: {
    clientTitles() {
      let clientTitles = []

      for (let clientId of this.item.clientIds) {
        const clientTitle = _.get(this.availableClientsById, [clientId, 'title'], null)

        if (!clientTitle) {
          continue
        }

        clientTitles.push(clientTitle)
      }

      return _.join(clientTitles, ', ')
    },
  },
  methods: {
    handlePatientClick() {
      this.$router.push(`/patients/${this.item.id}`)
    },
    reformatDate: reformatDate,
  }
}
</script>

<style scoped>
  .order {
    cursor: pointer;
  }
</style>